import { connect } from 'react-redux';
import { signup, loadJobs } from '../reducers/auth.reducers';
import { errorNotification } from '../reducers/notification.reducers';
import Signup from './signup';

const mapDispatchToProps = dispatch => ({
  signup: form => dispatch(signup(form)),
  loadJobs:() => dispatch(loadJobs()),
  showValidationError: (error) => dispatch(errorNotification(error))
});

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
  userName: state.authentication.userName,
  errorMessage: state.authentication.errorMessage,
  loading: state.authentication.loading,
  jobs: state.authentication.jobs,
  config: state.authentication.config,
});

export default connect(mapStateToProps, mapDispatchToProps)(Signup);



// WEBPACK FOOTER //
// ./src/app/signup/signup.container.js